export const GenderConst = {
    Male: {
        id: 1,
        label: 'Male',
        value: 'M'
    },
    Female: {
        id: 2,
        label: 'Female',
        value: 'F'
    },
    All: {
        label: 'All',
        value: 'A'
    }
}